import type { Logger, NamedLogger } from "./types";

const combine = (a: string, b: string) => `${a}.${b}`;

/** NamedLogger wraps the provided Logger and adds the caller name to each log message. */
export class Named implements NamedLogger {
  constructor(
    readonly logger: Logger,
    readonly caller: string
  ) {}

  error(errCode: string | number, message: string, error: unknown, optionalParams?: Record<string, unknown>) {
    const errCodeStr = typeof errCode === "number" ? String(errCode) : errCode;
    this.logger.error(errCodeStr, this.caller, message, error, optionalParams);
  }

  info(message: string, optionalParams?: Record<string, unknown>) {
    this.logger.info(this.caller, message, optionalParams);
  }

  warn(message: string, optionalParams?: Record<string, unknown>) {
    this.logger.warn(this.caller, message, optionalParams);
  }

  child(caller: string) {
    return new Named(this.logger, combine(this.caller, caller));
  }
}
